import { createTermTagManager } from '../../utils/createTermTagManager';

export const tour3dTagManager = createTermTagManager({
  jsonQueryKey: 'tour_3d',
  label: '3D-туры',
  id: 'tour3d',
});
